// src/features/imports/ImportSessionReview.jsx
//
// LSE-ADD-DATA-MODAL-S2 — Per-session diff review (Modal variant).
// INGEST-WIZARD-UX-3 — Thin Modal wrapper around the shared ImportReviewPanel.
//
// Workflow:
//   Queue path: PendingImportsQueue → ImportSessionReview (Modal) → ImportReviewPanel
//   Wizard path: ImportWizard step 4 → ImportReviewPanel (inline, no Modal)
//
// Props:
//   sessionId    number
//   onBack       () => void  — return to PendingImportsQueue
//   onRestage    () => void  — optional, re-upload from expired state

import React, { useState } from "react";
import { Modal } from "../../components/Modal.jsx";
import { ImportReviewPanel } from "./components/ImportReviewPanel.jsx";

export function ImportSessionReview({ sessionId, onBack, onRestage }) {
  const [title,    setTitle]    = useState("Import Review");
  const [subTitle, setSubTitle] = useState(undefined);

  return (
    <Modal
      isOpen
      onClose={onBack}
      maxWidth={1260}
      disableBackdropClose
      title={title}
      subTitle={subTitle}
      testId="import-session-review-modal"
    >
      <ImportReviewPanel
        sessionId={sessionId}
        onBack={onBack}
        onRestage={onRestage}
        onTitleChange={(t, s) => { setTitle(t); setSubTitle(s); }}
      />
    </Modal>
  );
}
